import { useFormik } from "formik";
import { useState } from "react";
import { useHistory } from "react-router-dom";
import { ChangePassword as ChangePasswordApi } from "redux/profile/changePass/changePass";
import * as Yup from "yup";
// import { ModalProgressBar } from "../../../_metronic/_partials/controls";
import { handleNotificationAlertTryUpdate } from "common/method/handleNotificationAlert";
import CardViewRegister from "./cardPass";

export default function StepThree({
  setIndexChild,
  setLoading,
  national_id,
  title,
  loading,
}) {
  const [isError, setisError] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);
  const { push } = useHistory();

  const saveUser = (values, setStatus, setSubmitting, resetForm) => {
    setLoading(true);
    setisError(false);
    setIsSuccess(false);

    if (values) {
      ChangePasswordApi(values.new_username, values.password)
        .then((res) => {
          let isOk = handleNotificationAlertTryUpdate(res);
          setLoading(false);
          setSubmitting(false);
          if (isOk) {
            setIsSuccess(true);
            setisError(false);
            setStatus({ success: true });
            resetForm(values);
            setIndexChild(0);
          } else {
            setStatus({ success: false });
            setisError(true);
          }
        })
        .catch((err) => {
          setLoading(false);
          setSubmitting(false);
          setStatus({ success: false });
          setisError(true);
        });
    } else {
      setisError(true);
    }
  };

  const initialValues = {
    currentPassword: "",
    password: "",
    cPassword: "",
    new_username: "",
  };

  const Schema = Yup.object().shape({
    // currentPassword: Yup.string().required("گذرواژه فعلی لازم است"),
    password: Yup.string()
      .required("گذرواژه جدید لازم است")
      .min(8, "حداقل 8 کاراکتر")
      .matches(
        /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d*@$!%*#?&]{8,}$/,
        "رمز عبور باید ۸کاراکتر و شامل عدد و حروف کوچک و بزرگ انگلیسی باشد"
      ),
    cPassword: Yup.string()
      .required("تأیید رمز عبور لازم است")
      .when("password", {
        is: (val) => (val && val.length > 0 ? true : false),
        then: Yup.string().oneOf(
          [Yup.ref("password")],
          "گذرواژه و تأیید گذرواژه مطابقت نداشت"
        ),
      }),
  });

  const getInputClasses = (fieldname) => {
    if (formik.touched[fieldname] && formik.errors[fieldname]) {
      return "is-invalid";
    }

    if (formik.touched[fieldname] && !formik.errors[fieldname]) {
      return "is-valid";
    }

    return "";
  };

  const formik = useFormik({
    initialValues,
    validationSchema: Schema,
    onSubmit: (values, { setStatus, setSubmitting, resetForm }) => {
      saveUser(values, setStatus, setSubmitting, resetForm);
    },
  });

  return (
    <>
      <CardViewRegister
        setIndexChild={setIndexChild}
        formik={formik}
        isSuccess={isSuccess}
        setisError={setisError}
        isError={isError}
        setIsSuccess={setIsSuccess}
        getInputClasses={getInputClasses}
        title={title}
        loading={loading}
      />
    </>
  );
}
